import React from "react";
import { motion } from "framer-motion";
import { LockSimple, LockSimpleOpen } from "@phosphor-icons/react";

export const WatchGate = ({ pct, required, compact }) => {
  const unlocked = pct >= required;
  const width = Math.min(100, (pct / Math.max(required, 1)) * 100);
  return (
    <div className={`mt-4 rounded-2xl border px-4 py-3 ${unlocked ? "border-emerald-500/30 bg-emerald-500/[0.06]" : "border-white/10 bg-white/[0.03]"}`} data-testid="public-watch-progress">
      <div className={`flex items-center justify-between gap-3 ${compact ? "text-[11px]" : "text-xs sm:text-sm"}`}>
        <span className="flex items-center gap-2 font-semibold">
          {unlocked ? <LockSimpleOpen size={16} className="text-emerald-400" weight="bold" /> : <LockSimple size={16} className="text-[#FFB30F]" weight="bold" />}
          {unlocked ? "Oferta liberada!" : `Assista ${required}% do vídeo para liberar a oferta`}
        </span>
        <span className="tabular-nums text-slate-400" data-testid="public-watch-progress-value">{Math.min(pct, 100)}%</span>
      </div>
      <div className="mt-2.5 h-2 rounded-full bg-white/10 overflow-hidden">
        <motion.div
          className={`h-full rounded-full ${unlocked ? "bg-emerald-400" : "bg-gradient-to-r from-[#FFB30F] to-[#ffd36b]"}`}
          animate={{ width: `${width}%` }}
          transition={{ duration: 0.4, ease: "easeOut" }}
        />
      </div>
    </div>
  );
};
